module.exports = __webpack_public_path__ + "static/img/presysv60.ebece9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv60.png
// module id = Ngwq
// module chunks = 1